import React from 'react';

const Footer = () => (
  <footer className="container mx-auto py-16 px-3 mt-48 mb-8 text-gray-800">
        <p className="mt-5">Website built w/ ❤ by Owen Kaplan</p>
  </footer>
);

export default Footer;
